import { atom, selector } from "recoil";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";
import moment from "moment";

export const topupReportListState = atom({
    key: 'topupReportListState',
    default: [],
})

export const topupReportCustomerState = atom({
    key: 'topupReportCustomerState',
    default: {
        data: [],
        ovf: false,
    }
})

export const topupReportStatusState = atom({
    key: 'topupReportStatusState',
    default: {
        data: [],
        ovf: false,
    }
})

export const topupReportFromDateState = atom({
    key: 'topupReportFromDateState',
    default: moment().subtract(1, 'month').format('YYYY-MM-DD'),
})

export const topupReportToDateState = atom({
    key: 'topupReportToDateState',
    default: moment().format('YYYY-MM-DD'),
})

export const topupReportCustomerValueState = atom({
    key: 'topupReportCustomerValueState',
    default: { label: "All", value: 0 },
})

export const topupReportStatusValueState = atom({
    key: 'topupReportStatusValueState',
    default: { label: "All", value: "all" },
})

export const modalConfigDefault = { size: "lg", wizard: false }

export const topupReportFilterState = selector({
    key: 'topupReportFilterState',
    get: ({ get }) => ([
        {
            label: 'From Date',
            size: 6,
            offset: 0,
            required: true,
            type: 'datepicker',
            value: get(topupReportFromDateState),
        },
        {
            label: 'To Date',
            size: 6,
            offset: 0,
            required: true,
            type: 'datepicker',
            value: get(topupReportToDateState),
        },
        {
            label: 'Customer',
            size: 6,
            offset: 0,
            required: false,
            type: 'select',
            value: get(topupReportCustomerValueState),
            list: get(topupReportCustomerState),
        },
        {
            label: 'Status',
            size: 6,
            offset: 0,
            required: false,
            type: 'select',
            value: get(topupReportStatusValueState),
            list: get(topupReportStatusState),
        },
    ]),
    set: ({ set }, e) => {
        if(e.filterLabel === 'From Date'){
            set(topupReportFromDateState, e.value)
        }
        if(e.filterLabel === 'To Date'){
            set(topupReportToDateState, e.value)
        }
        if(e.filterLabel === 'Customer'){
            set(topupReportCustomerValueState, e.value)
        }
        if(e.filterLabel === 'Status'){
            set(topupReportStatusValueState, e.value)
        }
    }
})

export const formModes = {
    view: [ { name: 'Default View' } ],
}

export const topupReportDataStructureState = selector({
    key: 'topupReportDataStructureState',
    get: ({ get }) => (
        [
            {
                label: 'Reference',
                field: 'transaction_number',
                type: 'text',
                order: { table: 1, form: 1 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }],
            },
            {
                label: 'Customer',
                field: 'customer_name',
                type: 'text',
                order: { table: 2, form: 2 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }],
            },
            {
                label: 'Date',
                field: 'topup_date',
                type: 'date',
                order: { table: 3, form: 3 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }],
            },
            {
                label: 'Amount',
                field: 'amount',
                type: 'number',
                order: { table: 4, form: 4 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }],
            },
            {
                label: 'GST',
                field: 'tax_amount',
                type: 'number',
                order: { table: 5, form: 5 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }],
            },
            {
                label: 'Total Paid',
                field: 'net_amount',
                type: 'number',
                order: { table: 6, form: 6 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }],
            },
            {
                label: 'Status',
                field: 'status',
                type: 'text',
                order: { table: 7, form: 7 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }],
            },
            // Finance-only, matching the transaction report and the topups list.
            {
                label: 'Fusion Receipt',
                field: 'fusion_receipt_number',
                type: 'text',
                permission: ':read-financeReports',
                order: { table: 8, form: 8 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }],
            },
        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
